import {
  MATCHING_INIT_LOADING,
  MATCHING_INIT_SUCCESS,
  MATCHING_INIT_FAIL,
  BATCH_MATCH_TRANS_INIT_LOADING,
  BATCH_MATCH_TRANS_INIT_SUCCESS,
  BATCH_MATCH_TRANS_INIT_FAIL,
  PERFORM_MATCH_INIT_LOADING,
  PERFORM_MATCH_INIT_SUCCESS,
  PERFORM_MATCH_INIT_FAIL,
  MATCH_LOAD_DATA,
  MATCH_LOAD_LISTING,
  MATCH_DATA_EDIT,
  INDIC_UNLOCK
} from '@/store/types'

export const init = {
  [MATCHING_INIT_LOADING](state) {
    state.init = 0
    state.initErr = []
    state.menu = {}
  },
  [MATCHING_INIT_SUCCESS](state, data) {
    state.init = 1
    state.initErr = []
    state.menu = data.menu
  },
  [MATCHING_INIT_FAIL](state, error) {
    state.init = 2
    state.initErr = error
    state.menu = {}
  },
  [BATCH_MATCH_TRANS_INIT_LOADING](state) {
    state.batchMatchTrans.init = 0
    state.batchMatchTrans.initErr = []
    state.batchMatchTrans.menu = {}
  },
  [BATCH_MATCH_TRANS_INIT_SUCCESS](state, data) {
    state.batchMatchTrans.init = 1
    state.batchMatchTrans.initErr = []
    state.batchMatchTrans.menu = data.menu
  },
  [BATCH_MATCH_TRANS_INIT_FAIL](state, error) {
    state.batchMatchTrans.init = 2
    state.batchMatchTrans.initErr = error
    state.batchMatchTrans.menu = {}
  },
  [PERFORM_MATCH_INIT_LOADING](state) {
    state.performMatch.init = 0
    state.performMatch.initErr = []
    state.performMatch.menu = {}
  },
  [PERFORM_MATCH_INIT_SUCCESS](state, data) {
    state.performMatch.init = 1
    state.performMatch.initErr = []
    state.performMatch.menu = data.menu
  },
  [PERFORM_MATCH_INIT_FAIL](state, error) {
    state.performMatch.init = 2
    state.performMatch.initErr = error
    state.performMatch.menu = {}
  },
  [MATCH_LOAD_DATA](state, data) {
    state.matchData.branch = data.branch
    state.matchData.accountNo = data.acctNo
    state.matchData.type = data.type
    state.matchData.documentNo = data.docNo
    state.matchData.fund = data.fund
    state.matchData.suffix = data.suffix
    state.matchData.action = data.action
    state.matchData.acctYr = data.acctYr
    state.matchData.acctMth = data.acctMth
    state.matchData.curr = data.curr
    state.matchData.frmModule = data.frmModule
    state.matchData.printDoc = data.printDoc
    state.matchData.mdJrnl = data.mdJrnl
    state.matchData.mdAcctNo = data.mdAcctNo
    state.matchData.mdBranch = data.mdBranch
    state.matchData.mdType = data.mdType
    state.matchData.mdDocNo = data.mdDocNo
    state.matchData.mdFund = data.mdFund
    state.matchData.mdSuffix = data.mdSuffix
    state.matchData.matchedOn = data.matchedOn
    state.matchData.mdProgId = data.mdProgId
  },
  [MATCH_LOAD_LISTING](state, data) {
    state.matchSelectedList.selectedMatchListing = []
    state.matchSelectedList.selectedMatchListing = data
  },
  [MATCH_DATA_EDIT](state, data) {
    state.matchDataEdit.matchOn = data.matchOn
    state.matchDataEdit.matchedRecTransDate = data.matchedRecTransDate
  },
  [INDIC_UNLOCK](state, data) {
    state.recLock.isUnlock = data
  }
}
